var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "34px",
    viewBox: "0 0 27 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "53.0817133%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4157A6",
    stopOpacity: 0.534937719,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E68C5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5645161,0.288675135 L22.0126936,5.74358293 C22.3220947,5.92221572 22.5126936,6.25234274 22.5126936,6.60960833 L22.5126936,17.5194239 C22.5126936,17.8766895 22.3220947,18.2068165 22.0126936,18.3854493 L12.5645161,23.8403571 C12.2551151,24.0189899 11.8739172,24.0189899 11.5645161,23.8403571 L2.11633868,18.3854493 C1.8069376,18.2068165 1.61633868,17.8766895 1.61633868,17.5194239 L1.61633868,6.60960833 C1.61633868,6.25234274 1.8069376,5.92221572 2.11633868,5.74358293 L11.5645161,0.288675135 C11.8739172,0.11004234 12.2551151,0.11004234 12.5645161,0.288675135 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(1.387097, 2.193548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon-Copy-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0BC7C2",
    strokeWidth: 2,
    d: "M13.0645161,-0.577350269 C12.445714,-0.934615859 11.6833183,-0.934615859 11.0645161,-0.577350269 L1.61633868,4.87755753 C0.997536523,5.23482312 0.616338677,5.89507715 0.616338677,6.60960833 L0.616338677,17.5194239 C0.616338677,18.2339551 0.997536523,18.8942091 1.61633868,19.2514747 L11.0645161,24.7063825 C11.3739172,24.8850153 11.7192167,24.9743317 12.0645161,24.9743317 C12.4098156,24.9743317 12.7551151,24.8850153 13.0645161,24.7063825 L22.5126936,19.2514747 C23.1314957,18.8942091 23.5126936,18.2339551 23.5126936,17.5194239 L23.5126936,6.60960833 C23.5126936,5.89507715 23.1314957,5.23482312 22.5126936,4.87755753 L13.0645161,-0.577350269 Z"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#324380",
    strokeWidth: 1,
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(8.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon",
    fill: "#FFFFFF",
    points: "4.33012702 0.5 8.66025404 3 8.66025404 8 4.33012702 10.5 0 8 0 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.119512649,
    points: "4.33012702 5.8622449 0 3 0 8 4.33012702 10.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#000000",
    opacity: 0.119512649,
    transform: "translate(6.495191, 6.750000) scale(-1, 1) translate(-6.495191, -6.750000) ",
    points: "8.66025498 5.8622449 4.33012796 3 4.33012796 8 8.66025498 10.5"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Shadow",
    fill: "#323A46",
    cx: 12.1129032,
    cy: 29.3064516,
    r: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.1129032,
    y1: 24.3064516,
    x2: 12.1129032,
    y2: 27.4564516,
    id: "Line",
    stroke: "#323A46",
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryGhost);
export default __webpack_public_path__ + "static/media/delivery-ghost.1c417c6cd09fdaf2f5c74459bceb635c.svg";
export { ForwardRef as ReactComponent };